import type { TRepoSPVMessages, TRepoUiSpvGrid } from "@app/types/insider";
import { SPV_CONTRACTOR_MIRROR, SPV_RIGHT_TABS } from "@app/state/constants";

import type { TBlueObj } from "@app/types/insider";
type TUiSpvMain = {
  currentRecord: TRepoSPVMessages;
  otherCurrentRecord: TRepoSPVMessages;
};

export const uiSpvMain: TBlueObj<TUiSpvMain> = {
  name: "uiSpvMain",
  initialState: {
    currentRecord: {} as TRepoSPVMessages,
    otherCurrentRecord: {} as TRepoSPVMessages,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};

export const uiSpvGrid: TBlueObj<TRepoUiSpvGrid> = {
  name: "uiSpvGrid",
  initialState: {
    colorized: true,
    // selectedCIF: '',
    selectedRightTab: SPV_RIGHT_TABS.FILE as
      | "FILES"
      | "CONTRACTOR"
      | "OPERATIONS",
    selectedCtorMirrorTab: SPV_CONTRACTOR_MIRROR.CTR_MIRR_TMP,
    selectedContactID: -1,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
